import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'
import withProps from 'recompose/withProps'
import withHandlers from 'recompose/withHandlers'
import withState from 'recompose/withState'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import { PlaybooksFrequency } from 'app/modules/playbook/constants'

import Review from './component'

const mapStateToProps = state => {
  const userListIds = PlaybookSelectors.userListIds(state)
  return {
    userListIds,
    draft: PlaybookSelectors.draft(state),
    reportType: PlaybookSelectors.reportType(state),
    isEmailPlaybook: PlaybookSelectors.getIsEmailPlaybook(state),
    draftFrequency: PlaybookSelectors.draftFrequency(state),
    audience: PlaybookSelectors.audience(state),
    numConditions: PlaybookSelectors.getNumConditions(state),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setDraftFrequency: PlaybookActions.setDraftFrequency,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState(
    'playbookFrequency',
    'setPlaybookFrequency',
    props => props.draftFrequency || PlaybooksFrequency.ONCE
  ),
  withProps(props => ({
    hasSegmentSelected: !!props.userListIds && props.userListIds.size > 0,
    isOnce: props.playbookFrequency === PlaybooksFrequency.ONCE,
    isSession: props.playbookFrequency === PlaybooksFrequency.SESSION,
    isAlways: props.playbookFrequency === PlaybooksFrequency.ALWAYS,
  })),
  withHandlers({
    handleSetFrequency: props => ({ target: { value }}) => {
      props.setPlaybookFrequency(value) // set locally for speedy UI...
      props.actions.setDraftFrequency(value)
    },
  })
)(Review)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingAdvanced/index.js